import { getWebOrderByUid } from '../api/order.api';

export const getWebOrderByUidEvent = getWebOrderByUid.matchFulfilled;
